<div class="gw-page-spacer">
    <slot />
</div>

<style lang="postcss">
    .gw-page-spacer {
        padding: 62px 0 100px;
        @media (max-width: 1150px) {
            padding: 60px 0 60px;
        }
    }
</style>
